import React from 'react';

const Step1Documents = ({ onClose, setCurrentStep }) => {
  return (
    <div className="modal_content_body">
      <h3 className="ppt_form_title mb-5 text-center">Documents you will need</h3>
      <ol className="ppt_list_gen">
        <li>Government ID or passport</li>
        <li>Smartphone or webcam required for Face ID verification.</li>
        <li>Bank statement with your name and address, dated within the last month.</li>
        <li>Utility bill (internet, water, or electricity) with your address, dated within the last three months.</li>
      </ol>
      <div className="d-flex justify-content-end gap-3 pt-4 kyc_btns">
        <button onClick={onClose} className="ppt_btn_secondary alt text-dark">Cancel</button>
        <button onClick={() => setCurrentStep(2)} className="ppt_btn_primary alt">Next</button>
      </div>
    </div>
  );
};

export default Step1Documents;